/**
 * Session replay is limited to real self-serve prospects. Internal testers are
 * never recorded, and an unresolved address fails closed (treated as internal).
 */
const INTERNAL_EMAIL_DOMAINS = new Set(['userose.ai', 'hexa.com']);

export function isInternalEmail(email: string | undefined | null): boolean {
    const domain = email?.split('@')[1]?.toLowerCase() ?? '';
    // No resolvable address → fail closed (never record).
    if (!domain) return true;
    // inboundx.* (.ai / .app / .com …) are all internal.
    if (domain.startsWith('inboundx.')) return true;
    return INTERNAL_EMAIL_DOMAINS.has(domain);
}
